import { Entity } from '../intent/types';
import { createRequestType } from '../../helpers/requestType';

export const FILL_ENTITIES = 'FILL_ENTITIES';
interface FillEntitiesAction {
  type: typeof FILL_ENTITIES;
  payload: [Entity];
}

export const saveEntityActionType = createRequestType('SAVE_ENTITY');
interface SaveEntityAction {
  type: typeof saveEntityActionType.request;
  payload: Entity;
}

interface SaveSuccessEntityAction {
  type: typeof saveEntityActionType.success;
  payload: Entity;
}

interface SaveFailureEntityAction {
  type: typeof saveEntityActionType.failure;
  payload: any;
}

export const deleteEntityActionType = createRequestType('DELETE_ENTITY');
interface DeleteEntityAction {
  type: typeof deleteEntityActionType.request;
  payload: string;
}

interface DeleteSuccessEntityAction {
  type: typeof deleteEntityActionType.success;
  payload: string;
}

interface DeleteFailureEntityAction {
  type: typeof deleteEntityActionType.failure;
  payload: any;
}

export type EntityActionTypes =
  | FillEntitiesAction
  | SaveEntityAction
  | SaveSuccessEntityAction
  | SaveFailureEntityAction
  | DeleteEntityAction
  | DeleteSuccessEntityAction
  | DeleteFailureEntityAction;
